import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { LoaderComponent } from './loader/loader.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import { Loader2Component } from './loader2/loader2.component';
import { WeekDateSlider } from './week-date-slider/week-date-slider.component';

@NgModule({
  declarations: [PagetitleComponent,  LoaderComponent, Loader2Component, WeekDateSlider],
  imports: [
    CommonModule,
    FormsModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
  ],
  exports: [PagetitleComponent, LoaderComponent, MatPaginatorModule, WeekDateSlider, Loader2Component]
})
export class UIModule { }
